import React from 'react';
import { AboutMeFooterStyled } from './about-me-footer.styled';

function AboutMeFooter() {
  return (
    <AboutMeFooterStyled>
      <span>Copyright © 2021 by </span>
      <a href="https://aiwan.run">Debbl</a>
    </AboutMeFooterStyled>
  );
}

export default AboutMeFooter;
